import { render } from "./Lots.vue?vue&type=template&id=9598b248&scoped=true&ts=true&lang=pug"
import script from "./Lots.vue?vue&type=script&lang=ts&setup=true"
export * from "./Lots.vue?vue&type=script&lang=ts&setup=true"

import "./Lots.vue?vue&type=style&index=0&id=9598b248&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9598b248"]])

export default __exports__